import { SliderSizes, SliderVariants } from '@gotamedia/fluffy/Slider'
import { useLoaderData } from '@remix-run/react'
import type { MouseEvent, SyntheticEvent } from 'react'
import { useCallback, useState } from 'react'
import useSearchParamValues from "~/hooks/useSearchParamValues"
import useViewSize from '~/hooks/useViewSize'
import type { ChurchEventAdItem, SearchResponse } from '~/modules/churchevent/types'
import { ChurchEventsAdItemCategoryNames } from "~/modules/churchevent/types"
import { ItemType } from "~/services/resolvers/types"
import NoResults from '../NoResults/NoResults'
import * as Styled from './style'
import type * as Types from './types'

const ChurchEventWidgetCards: Types.ChurchEventWidgetCardsComponent = (props: Types.ChurchEventWidgetCardProps) => {
    const { legacy } = useSearchParamValues(['legacy'])
    const legacyMode = legacy === "true"

    const [index, setIndex] = useState(0)
    const [clientX, setClientX] = useState(0)
    const [hover, setHover] = useState(false)

    const data = useLoaderData<SearchResponse>()
    const { isSmall, isMedium, isLarge } = useViewSize()

    const { width } = props
    const items: ChurchEventAdItem[] = ( data.payload?.data_list || [])

    const today = new Date()


    const filteredItems = items.filter(item => {
        return (
            item.category?.name === ChurchEventsAdItemCategoryNames.Misc &&
            item.event_start_time &&
            today <= new Date(item.event_start_time.replace(/-/g, "/"))
        )
    });

    const chunk = (arr:ChurchEventAdItem[] , size: number) =>
        Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
            arr.slice(i * size, i * size + size)
        )

    const updateClientX = useCallback((clientX: number) => {
        setClientX(clientX)
    }, [])

    const updateIndex = useCallback((newIndex: number) => {
        setIndex(newIndex)
    }, [])

    const dragOrClick = useCallback((event: MouseEvent,  uuid: string ) => {
        if (event.clientX < clientX + 5 && event.clientX > clientX - 5) {
            window.open(`/${uuid}`)
        }
    }, [clientX])

    const replaceImage =  useCallback((uid: string) => (error: SyntheticEvent<HTMLImageElement>) => {
        const elements = document.getElementsByClassName(uid)

        for (let element of elements) {
            if ((element as HTMLImageElement).src !== BrokenImage) {
                (element as HTMLImageElement).src = BrokenImage
            }
        }
    }, [])

    const chunkSize = width && width > 0 ? Math.floor(width / 180) : isLarge() ? 4 : !isSmall() ? 3 : 2
    const height = legacyMode ? isSmall() ? 220 : 272 : isSmall() ? 216 : 256

    const result = filteredItems ? chunk(filteredItems, chunkSize) : []

    const BrokenImage = "/images/Church.svg"
    const brokenImageLinks = [
        "https://cargodisplayads.com/gota_event/api/v1_1/adImage/default/120",
        "https://cargodisplayads.com/gota_event_test/api/v2/image/default/120",
        "https://cargodisplayads.com/gota_event/api/v2/image/default/120"
    ]

    return (
        <Styled.SliderContainer legacy={legacyMode}>
            {result.length > 0 ? (
                <Styled.Slider
                    legacy={legacyMode}
                    width={width || 0}
                    index={index}
                    variant={SliderVariants.Contrast}
                    size={SliderSizes.Small}
                    onChange={(newIndex: number) => updateIndex(newIndex)}
                    onMouseDown={(e: MouseEvent) => updateClientX(e.clientX)}
                    loop={false}
                    slidesCount={result.length}
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    shouldAutoPlay={false}
                    dynamicBullets={!isLarge()}
                >
                    <Styled.SliderStiles slideProps={{ style: { margin: "0 auto", width: "auto" }}}>

                        {result.map((item, idx) => {
                            return (
                                <Styled.CardContainer key={`${idx}`}>
                                    {
                                        item.map((it: ChurchEventAdItem, idx) => {

                                            if (today <= new Date(it.event_start_time.replace(/-/g, "/"))
                                            ) {
                                                return (
                                                    <Styled.CardWrapper
                                                        legacy={legacyMode}
                                                        type={data._type}
                                                        onMouseUp={(e) => dragOrClick(e, it.uid)}
                                                        width={width ? (((width-chunkSize-44) / chunkSize)-10) : undefined}
                                                        key={`${it.uid}-${idx}`}
                                                    >
                                                        <Styled.ImageContainer legacy={legacyMode}>
                                                            <Styled.CardImage
                                                                legacy={legacyMode}
                                                                className={it.uid}
                                                                type={data._type || ItemType.ChurchEventAd}
                                                                onError={replaceImage(it.uid)}
                                                                src={it.main_image && !brokenImageLinks.includes(it.main_image) ? it.main_image : BrokenImage}
                                                            />
                                                        </Styled.ImageContainer>

                                                        <Styled.Title>{it.title}</Styled.Title>
                                                        {it.subtitle ? (
                                                            <Styled.SubTitle>{it.subtitle}</Styled.SubTitle>
                                                        ) : (
                                                            null
                                                        )}
                                                        <Styled.Info>{it.subject_location}</Styled.Info>
                                                        <Styled.Info>
                                                            {new Date(it.event_start_time.replace(/-/g, "/")).toLocaleString(undefined, {
                                                                month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"
                                                            })}
                                                        </Styled.Info>
                                                    </Styled.CardWrapper>
                                                )
                                            } else {
                                                return null
                                            }
                                        })
                                    }
                                </Styled.CardContainer>
                            )
                        })}
                    </Styled.SliderStiles>
                    {
                        items?.length > chunkSize ? (
                            <>
                                <Styled.Slider.SliderBullets />

                                {
                                    (isLarge() || isMedium() && !legacyMode) && hover ? (
                                        <Styled.Slider.Navigation />
                                    ) : (
                                        null
                                    )
                                }
                            </>
                        ) : (
                            null
                        )
                    }
                </Styled.Slider>
            ) : (
                <NoResults heigth={height} type={data._type} width={width}/>
            )}

        </Styled.SliderContainer>
    )
}

export default ChurchEventWidgetCards
